var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { joiResolver } from '@hookform/resolvers/joi';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { navigateTo, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { loadDelegatees, loadDelegators, loadPendingOutgoingUndelegations, } from '@popup/steem/actions/delegations.actions';
import { DelegationType } from '@popup/steem/pages/app-container/home/delegations/delegation-type.enum';
import { ResourceItemComponent } from '@popup/steem/pages/app-container/home/resources-section/resource-item/resource-item.component';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import { DelegationUtils } from '@popup/steem/utils/delegation.utils';
import { FavoriteUserUtils } from '@popup/steem/utils/favorite-user.utils';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@steempro/steem-keychain-commons';
import Joi from 'joi';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { FormContainer } from 'src/common-ui/form-container/form-container.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { FormInputComponent } from 'src/common-ui/input/form-input.component';
import { InputType } from 'src/common-ui/input/input-type.enum';
import { Separator } from 'src/common-ui/separator/separator.component';
import { Screen } from 'src/reference-data/screen.enum';
import { FormUtils } from 'src/utils/form.utils';
import FormatUtils from 'src/utils/format.utils';
const rules = FormUtils.createRules({
    username: Joi.string().required(),
    amount: Joi.number().required().min(0).max(Joi.ref('$maxAmount')),
});
const Delegations = ({ currencyLabels, activeAccount, delegations, globalProperties, formParams, localAccounts, navigateToWithParams, navigateTo, setSuccessMessage, setErrorMessage, loadDelegators, loadDelegatees, addToLoadingList, removeFromLoadingList, setTitleContainerProperties, loadPendingOutgoingUndelegations, }) => {
    const [available, setAvailable] = useState();
    const { control, handleSubmit, setValue, watch } = useForm({
        defaultValues: {
            username: formParams.username ? formParams.username : '',
            amount: formParams.amount ? formParams.amount : '',
            currency: currencyLabels.sp,
        },
        resolver: (values, context, options) => {
            const resolver = joiResolver(rules, {
                context: { maxAmount: available },
                errors: { render: true },
            });
            return resolver(values, { maxAmount: available }, options);
        },
    });
    const [totalIncoming, setTotalIncoming] = useState('...');
    const [totalOutgoing, setTotalOutgoing] = useState('...');
    const [totalPendingOutgoingUndelegation, setTotalPendingOutgoingUndelegation,] = useState('...');
    const [autocompleteTransferUsernames, setAutocompleteTransferUsernames] = useState();
    const [incomingError, setIncomingError] = useState(null);
    const loadAutocompleteTransferUsernames = () => __awaiter(void 0, void 0, void 0, function* () {
        const autoCompleteListByCategories = yield FavoriteUserUtils.getAutocompleteListByCategories(activeAccount.name, localAccounts, { addExchanges: false });
        setAutocompleteTransferUsernames(autoCompleteListByCategories);
    });
    useEffect(() => {
        loadDelegators(activeAccount.name);
        loadDelegatees(activeAccount.name);
        loadPendingOutgoingUndelegations(activeAccount.name);
        setAvailable(0);
        loadAutocompleteTransferUsernames();
        setTitleContainerProperties({
            title: 'popup_html_delegations',
            isBackButtonEnabled: true,
        });
    }, []);
    useEffect(() => {
        if (delegations.pendingOutgoingUndelegation) {
            const totalPendingOutgoingUndelegationVests = delegations.pendingOutgoingUndelegation.reduce((prev, cur) => {
                return prev + cur.vesting_shares;
            }, 0);
            setTotalPendingOutgoingUndelegation(FormatUtils.toSP(totalPendingOutgoingUndelegationVests, globalProperties));
        }
        if (delegations.incoming) {
            const totalIncomingVests = delegations.incoming.reduce((prev, cur) => {
                return (prev + Number(cur.vesting_shares.toString().replace(' VESTS', '')));
            }, 0);
            setTotalIncoming(FormatUtils.toSP(totalIncomingVests.toString(), globalProperties));
        }
        else {
            setIncomingError('popup_html_error_retrieving_incoming_delegations');
        }
        if (delegations.outgoing) {
            let totalOutgoingVests = delegations.outgoing.reduce((prev, cur) => {
                return (prev + Number(cur.vesting_shares.toString().replace(' VESTS', '')));
            }, 0);
            totalOutgoingVests += delegations.pendingOutgoingUndelegation.reduce((prev, cur) => {
                return prev + cur.vesting_shares;
            }, 0);
            setTotalOutgoing(FormatUtils.toSP(totalOutgoingVests.toString(), globalProperties));
        }
        const totalHp = FormatUtils.toSP(activeAccount.account.vesting_shares, globalProperties);
        setAvailable(Math.max(totalHp - Number(totalOutgoing) - 5, 0));
    }, [delegations]);
    const setToMax = () => {
        setValue('amount', available);
    };
    const goToIncomings = () => {
        if (!incomingError)
            navigateToWithParams(Screen.INCOMING_OUTGOING_PAGE, {
                delegationType: DelegationType.INCOMING,
            });
    };
    const goToOutgoing = () => {
        navigateToWithParams(Screen.INCOMING_OUTGOING_PAGE, {
            delegationType: DelegationType.OUTGOING,
            totalPendingOutgoingUndelegation: totalPendingOutgoingUndelegation,
            available: available,
        });
    };
    const handleButtonClick = (form) => {
        if (parseFloat(form.amount.toString()) > parseFloat(available.toString())) {
            setErrorMessage('popup_html_power_up_down_error');
            return;
        }
        if (Number(form.amount) <= 0) {
            cancelDelegation(form);
        }
        const formattedAmount = `${parseFloat(form.amount.toString()).toFixed(3)} ${currencyLabels.sp}`;
        const stringifiedAmount = `${FormatUtils.formatCurrencyValue(parseFloat(form.amount.toString()))} ${currencyLabels.sp}`;
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_confirm_delegation', [
                stringifiedAmount,
                `@${form.username}`,
            ]),
            fields: [
                { label: 'popup_html_transfer_from', value: `@${activeAccount.name}` },
                { label: 'popup_html_transfer_to', value: `@${form.username}` },
                { label: 'popup_html_value', value: stringifiedAmount },
            ],
            title: 'popup_html_delegation',
            formParams: getFormParams(),
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_delegation_operation');
                try {
                    let success = yield DelegationUtils.delegateVestingShares(activeAccount.name, form.username, FormatUtils.fromSP(form.amount.toString(), globalProperties).toFixed(6) + ' VESTS', activeAccount.keys.active, options);
                    if (success) {
                        navigateTo(Screen.HOME_PAGE, true);
                        yield FavoriteUserUtils.saveFavoriteUser(form.username, activeAccount);
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else
                            setSuccessMessage('popup_html_delegation_successful');
                    }
                    else {
                        setErrorMessage('popup_html_delegation_fail');
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_delegation_operation');
                }
            }),
        });
    };
    const cancelDelegation = (form) => {
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_confirm_cancel_delegation_message'),
            fields: [
                { label: 'popup_html_transfer_from', value: `@${activeAccount.name}` },
                { label: 'popup_html_transfer_to', value: `@${form.username}` },
            ],
            title: 'popup_html_cancel_delegation',
            formParams: getFormParams(),
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_cancel_delegation_operation');
                try {
                    let success = yield DelegationUtils.delegateVestingShares(activeAccount.name, form.username, '0.000000 VESTS', activeAccount.keys.active, options);
                    if (success) {
                        navigateTo(Screen.HOME_PAGE, true);
                        yield FavoriteUserUtils.saveFavoriteUser(form.username, activeAccount);
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else
                            setSuccessMessage('popup_html_cancel_delegation_successful');
                    }
                    else {
                        setErrorMessage('popup_html_cancel_delegation_fail');
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_cancel_delegation_operation');
                }
            }),
        });
    };
    const getFormParams = () => {
        return watch();
    };
    return (React.createElement("div", { className: "delegations-page", "data-testid": `${Screen.DELEGATION_PAGE}-page` },
        React.createElement("div", { className: "resources" },
            React.createElement(ResourceItemComponent, { icon: SVGIcons.RESOURCE_ITEM_DELEGATION_INCOMING, label: "popup_html_total_incoming", value: `+${FormatUtils.withCommas(totalIncoming.toString())}
              ${currencyLabels.sp}`, onClick: goToIncomings, additionalClass: "blue" }),
            React.createElement(ResourceItemComponent, { icon: SVGIcons.RESOURCE_ITEM_DELEGATION_OUTGOING, label: "popup_html_total_outgoing", value: `-${FormatUtils.withCommas(totalOutgoing.toString())}
              ${currencyLabels.sp}`, onClick: goToOutgoing, additionalClass: "red" })),
        React.createElement("div", { className: "available-panel" },
            React.createElement("div", { className: "label" }, getMessage('popup_html_available')),
            React.createElement("div", { className: "value" },
                available && (React.createElement(React.Fragment, null,
                    FormatUtils.formatCurrencyValue(available),
                    " ",
                    currencyLabels.sp)),
                !available && React.createElement(React.Fragment, null, "..."))),
        React.createElement(FormContainer, { onSubmit: handleSubmit(handleButtonClick) },
            React.createElement("div", { className: "text" }, getMessage('popup_html_delegations_text')),
            React.createElement(Separator, { type: "horizontal" }),
            React.createElement("div", { className: "form-fields" },
                React.createElement(FormInputComponent, { name: "username", control: control, dataTestId: "input-username", type: InputType.TEXT, logo: SVGIcons.INPUT_AT, placeholder: "popup_html_username", label: "popup_html_username", autocompleteValues: autocompleteTransferUsernames }),
                React.createElement("div", { className: "amount-panel" },
                    React.createElement(FormInputComponent, { classname: "currency-fake-input", dataTestId: "currency-input", control: control, name: "currency", type: InputType.TEXT, label: "popup_html_currency", disabled: true }),
                    React.createElement(FormInputComponent, { name: "amount", control: control, dataTestId: "amount-input", type: InputType.NUMBER, label: "popup_html_transfer_amount", placeholder: "0.000", skipPlaceholderTranslation: true, rightActionIcon: SVGIcons.INPUT_MAX, rightActionClicked: setToMax }))),
            React.createElement(OperationButtonComponent, { dataTestId: "delegate-operation-submit-button", label: watch('amount') && Number(watch('amount')) === 0
                    ? 'popup_html_cancel_delegation'
                    : 'popup_html_delegate_to_user', onClick: handleSubmit(handleButtonClick), requiredKey: KeychainKeyTypesLC.active }))));
};
const mapStateToProps = (state) => {
    var _a, _b, _c;
    return {
        localAccounts: state.steem.accounts,
        activeAccount: state.steem.activeAccount,
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
        delegations: state.steem.delegations,
        globalProperties: state.steem.globalProperties.globals,
        formParams: ((_b = state.navigation.stack[0].previousParams) === null || _b === void 0 ? void 0 : _b.formParams)
            ? (_c = state.navigation.stack[0].previousParams) === null || _c === void 0 ? void 0 : _c.formParams
            : {},
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    navigateTo,
    setSuccessMessage,
    setErrorMessage,
    loadDelegators,
    loadDelegatees,
    addToLoadingList,
    removeFromLoadingList,
    setTitleContainerProperties,
    loadPendingOutgoingUndelegations,
});
export const DelegationsComponent = connector(Delegations);
